import { useTranslation } from 'react-i18next';

export default function Packages() {
  const { t } = useTranslation();

  const plans = [
    {
      nameKey: 'pkg_p1_name', subKey: 'pkg_p1_sub',
      investment: '€21,100', investmentRaw: 21100,
      yieldPct: 100, profitRaw: 21100, profit: '€21,100', totalReturn: '€42,200', multiplier: '×2',
      badge: null, badgeColor: null, featured: false,
      features: ['pkg_p1_f1','pkg_p1_f2','pkg_p1_f3','pkg_p1_f4','pkg_p1_f5'],
    },
    {
      nameKey: 'pkg_p2_name', subKey: 'pkg_p2_sub',
      investment: '€26,000', investmentRaw: 26000,
      yieldPct: 200, profitRaw: 52000, profit: '€52,000', totalReturn: '€78,000', multiplier: '×3',
      badge: 'pkg_popular', badgeColor: 'bg-green-500 text-white', featured: true,
      features: ['pkg_p2_f1','pkg_p2_f2','pkg_p2_f3','pkg_p2_f4','pkg_p2_f5','pkg_p2_f6'],
    },
    {
      nameKey: 'pkg_p3_name', subKey: 'pkg_p3_sub',
      investment: '€31,000', investmentRaw: 31000,
      yieldPct: 300, profitRaw: 93000, profit: '€93,000', totalReturn: '€124,000', multiplier: '×4',
      badge: 'pkg_maximum', badgeColor: 'bg-amber-400 text-amber-900', featured: false,
      features: ['pkg_p3_f1','pkg_p3_f2','pkg_p3_f3','pkg_p3_f4','pkg_p3_f5','pkg_p3_f6','pkg_p3_f7'],
    },
  ];

  return (
    <section id="packages" className="py-16 md:py-28 bg-[#111418]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/20 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-briefcase-line text-green-400 text-sm"></i>
            <span className="text-green-400 text-xs font-semibold uppercase tracking-wide">{t('pkg_badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-black text-white mb-4">
            {t('pkg_title_1')} <span className="text-yellow-400">{t('pkg_title_2')}</span> {t('pkg_title_3')}
          </h2>
          <p className="text-white/50 text-sm md:text-base max-w-xl mx-auto">{t('pkg_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 items-start">
          {plans.map((plan) => (
            <div key={plan.nameKey} className={`relative rounded-2xl transition-all duration-300 bg-white ${plan.featured ? 'border-2 border-green-400 md:scale-105' : 'border border-gray-100'}`}>
              {plan.badge && (
                <div className={`absolute -top-3.5 left-1/2 -translate-x-1/2 px-5 py-1 rounded-full text-xs font-bold whitespace-nowrap ${plan.badgeColor}`}>
                  {t(plan.badge)}
                </div>
              )}
              <div className="p-5 md:p-7">
                <div className="mb-4">
                  <h3 className="text-gray-900 font-bold text-lg md:text-xl mb-1">{t(plan.nameKey)}</h3>
                  <div className="text-gray-400 text-sm">{t(plan.subKey)}</div>
                </div>
                <div className="mb-3">
                  <div className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-1">{t('pkg_investment')}</div>
                  <div className="text-gray-900 font-black text-3xl md:text-4xl">{plan.investment}</div>
                </div>
                <div className="inline-flex items-center gap-1.5 bg-green-50 border border-green-200 rounded-full px-3 py-1 mb-4">
                  <i className="ri-time-line text-green-500 text-xs"></i>
                  <span className="text-green-700 text-xs font-bold">{t('pkg_term')}: {t('pkg_term_val')}</span>
                </div>
                <div className="border-t border-gray-100 my-4"></div>
                <div className="mb-2">
                  <div className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">{t('pkg_yield')}</div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`text-4xl md:text-5xl font-black ${plan.featured ? 'text-green-500' : 'text-green-600'}`}>{plan.multiplier}</span>
                    <div>
                      <div className="text-gray-500 text-xs">{t('pkg_yield')}</div>
                      <div className={`font-black text-xl ${plan.featured ? 'text-green-500' : 'text-green-600'}`}>{plan.yieldPct}%</div>
                    </div>
                  </div>
                  <div className="bg-green-50 border border-green-200 rounded-xl p-3 mb-1">
                    <div className="text-gray-500 text-xs mb-0.5">{t('pkg_profit_label')}</div>
                    <div className={`font-black text-2xl md:text-3xl ${plan.featured ? 'text-green-500' : 'text-green-600'}`}>{plan.profit}</div>
                  </div>
                  <div className="flex justify-between text-xs text-gray-400 px-1">
                    <span>{t('pkg_invested')} <strong className="text-gray-600">{plan.investment}</strong></span>
                    <span>{t('pkg_total')} <strong className="text-gray-700">{plan.totalReturn}</strong></span>
                  </div>
                </div>
                <div className="border-t border-gray-100 my-4"></div>
                <ul className="space-y-2 mb-6">
                  {plan.features.map((fk) => (
                    <li key={fk} className="flex items-center gap-2.5 text-xs md:text-sm text-gray-600">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0"><i className="ri-check-line text-green-500"></i></span>
                      {t(fk)}
                    </li>
                  ))}
                </ul>
                <button className={`w-full py-3 md:py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap ${plan.featured ? 'bg-green-500 hover:bg-green-400 text-white' : 'border-2 border-green-500 text-green-600 hover:bg-green-500 hover:text-white'}`}>
                  {t('pkg_btn')}
                </button>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center text-white/30 text-xs mt-6 md:mt-8">{t('pkg_disclaimer')}</p>
      </div>
    </section>
  );
}
